import React from 'react'
import Head from 'next/head'

export type SRPProps = {
    titleOverride?: string
    descriptionOverride?: string
}

export const SRP = ({ titleOverride }: SRPProps): JSX.Element => {
    return (
        <Head>
            <title>{titleOverride!}</title>
            <meta name="robots" content="noindex,nofollow" />
        </Head>
    )
}
